import { Tooltip } from 'antd';

/**
 * One count, in one of four honest states.
 *
 *   loading      a muted bar — NOT a spinner (twelve spinners in a column is noise), and
 *                NOT an em dash, because an em dash is a VALUE meaning "none available"
 *                and must not be indistinguishable from "still working".
 *   zero         a muted `0`. Zero officers posted to a unit is information, not a blank.
 *   a number     exact. [amended P1b] Server-side now: one `$group` over officers with
 *                an `ancestors` roll-up, so this is exact at any scale rather than only
 *                below the client-side census bound it used to depend on.
 *   unavailable  an em dash with a reason. [amended P1b] This state did NOT become dead
 *                when the counts became exact — it changed meaning. It now says "the
 *                tree payload has this unit and the counts payload does not", which is a
 *                partial or errored response, or a unit deactivated between the two
 *                fetches. Rendering a 0 there would be a lie.
 */
export const CountCell = ({
  value,
  loading,
  unavailableHint = 'No count was returned for this unit.',
}: {
  value: number | undefined;
  loading: boolean;
  unavailableHint?: string;
}) => {
  if (value === undefined) {
    if (loading) {
      return (
        <span
          className="inline-block h-3 w-8 animate-pulse rounded bg-secondary align-middle"
          aria-label="Loading count"
        />
      );
    }
    return (
      <Tooltip title={unavailableHint}>
        <span className="text-subtle">—</span>
      </Tooltip>
    );
  }

  return <span className={value === 0 ? 'text-muted-foreground tabular-nums' : 'tabular-nums'}>{value}</span>;
};
